import { PartnerType } from "@/app/utils/partners.enum";
import { createCustomerBody } from "../customerService/createCustomer";
import { streamRequest, StreamOptions } from "../http/sseClient";

export interface IIncome {
  registration: string;
  registrationDigit: string;
  valueIncome: number;
  codeBenefitSpecie?: number;
  codeReceiptDataId?: number;
}

export interface IBankAccount {
  bank: string;
  agency: string;
  account: string;
  accountDigit: string;
  agencyDigit: string;
  accountType?: string;
}
export interface CreateClientRequest extends Omit<
  createCustomerBody,
  "maritalStatus" | "bankAccount"
> {
  educationLevel?: number;
  maritalStatus?: number;
  fatherName?: string;
  income: IIncome;
  dataConsentId?: string;
  authorizeSMS?: boolean;
  hasVisualImpairment?: boolean;
  maritalStatusId?: number;
  educationLevelId?: number;
  bankAccount?: IBankAccount;
}

export interface CreateClientResponse {
  customerId: string;
  data: {
    clienteId: string;
    codumentosParaAnexar: string;
    mensagem: string;
    status: boolean;
  };
  errors: any;
  success: boolean;
  message: string;
}

export async function createClient(
  clientId: string,
  data: CreateClientRequest,
  options?: StreamOptions,
) {
  return streamRequest<CreateClientResponse>({
    method: "POST",
    path: `/crefisa/client/${clientId}`,
    body: data,
    journey: PartnerType.CREFISA,
    ...options,
  });
}
